import { css } from 'styled-components';
import { camelCaseToKebabCase, px } from '../utils';
import { maxMobileMediaQuery, minDesktopMediaQuery } from './medias';
const CSS_PROPERTIES_WITHOUT_UNITS = new Set(['flex', 'flexGrow', 'fontWeight', 'WebkitLineClamp']);
export function resolveCssValue(propertyName, value) {
  if (typeof value === 'string') {
    return value;
  }
  return CSS_PROPERTIES_WITHOUT_UNITS.has(propertyName) ? String(value) : px(value);
}
export function resolveResponsiveProp(property, value) {
  let isMobileBreakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (Array.isArray(value)) {
    if (value[0] !== value[1]) {
      return css(["", ";", ""], value[0] !== undefined && `${camelCaseToKebabCase(property)}: ${resolveCssValue(property, value[0])}`, value[1] !== undefined && `@media ${minDesktopMediaQuery()} {
          ${camelCaseToKebabCase(property)}: ${resolveCssValue(property, value[1])};
        }`);
    }
    return css(["", ":", ";"], camelCaseToKebabCase(property), resolveCssValue(property, value[0]));
  }
  if (typeof value === 'object') {
    const customMediaQuery = Object.keys(value).find(breakpointKey => !['desktop', 'mobile'].includes(breakpointKey));
    const customMediaRule = customMediaQuery ? `@media ${customMediaQuery} {${camelCaseToKebabCase(property)}: ${resolveCssValue(property, value[customMediaQuery])};}` : '';
    const mobileBreakpoint = isMobileBreakpoint ? `@media ${maxMobileMediaQuery()} {
          ${camelCaseToKebabCase(property)}: ${resolveCssValue(property, value.mobile)};
      }` : `${camelCaseToKebabCase(property)}: ${resolveCssValue(property, value.mobile)};`;
    return css(["", " @media ", "{", ":", ";}", ""], mobileBreakpoint, minDesktopMediaQuery(), camelCaseToKebabCase(property), resolveCssValue(property, value.desktop), customMediaRule);
  }
  return css(["", ":", ";"], camelCaseToKebabCase(property), resolveCssValue(property, value));
}
export function resolveResponsiveFlexArrayProp(property, propertyValue) {
  if (Array.isArray(propertyValue)) {
    if (property[0] === property[1] && propertyValue[0] === propertyValue[1]) {
      return css(["", ":", ";"], camelCaseToKebabCase(property[0]), resolveCssValue(property[0], propertyValue[0]));
    }
    return css(["@media ", "{", ":", ";}@media ", "{", ":", ";}"], maxMobileMediaQuery(), camelCaseToKebabCase(property[0]), resolveCssValue(property[0], propertyValue[0]), minDesktopMediaQuery(), camelCaseToKebabCase(property[1]), resolveCssValue(property[1], propertyValue[1]));
  } else {
    const [customMedia, customValue] = Object.entries(propertyValue)[2];
    return css(["@media ", "{", ":", ";}@media ", "{", ":", ";}@media ", "{", ":", ";}"], maxMobileMediaQuery(), camelCaseToKebabCase(property[0]), resolveCssValue(property[0], propertyValue.mobile), minDesktopMediaQuery(), camelCaseToKebabCase(property[1]), resolveCssValue(property[1], propertyValue.desktop), customMedia, camelCaseToKebabCase(property[1]), resolveCssValue(property[2] ?? property[1], customValue));
  }
}
export function mapResponsivePropToCssPropertyValues(responsiveProp, mappingCallback) {
  if (Array.isArray(responsiveProp)) {
    return responsiveProp.map(prop => mappingCallback(prop));
  }
  if (typeof responsiveProp === 'object') {
    const customMediaQuery = Object.keys(responsiveProp)[2];
    const customMediaValue = Object.values(responsiveProp)[2];
    const {
      mobile,
      desktop
    } = responsiveProp;
    const mappedObject = {
      mobile: mappingCallback(mobile),
      desktop: mappingCallback(desktop),
      [customMediaQuery]: mappingCallback(customMediaValue)
    };
    return mappedObject;
  }
  return mappingCallback(responsiveProp);
}